import React from 'react';

import { Clock, Reccuring, OneTime, Multiday, FreeAccess } from '../components/Icons/CustomIcons';

const ZeitangabenFormate = () => {
  return (
    <div className="drawer-page">
      <h1 className="text-2xl sm:text-3xl font-bold mb-4">Welche Art von Event möchten Sie eintragen?</h1>
      <p className="text-sm text-gray-700 mb-6">
        Wählen Sie die Kategorie, die am besten zu Ihrer Aktivität passt. Falls Sie unsicher sind,
        helfen Ihnen die Beispiele weiter.
      </p>

      <hr className="mb-6" />

      <div className="card p-6 mb-6">
        <h3> <Clock /> Öffnungszeiten</h3>
        <p className="text-sm text-gray-700 mb-2"><strong>Wann verwenden?</strong></p>
        <p className="text-sm text-gray-700 mb-3">
          Für Orte und Einrichtungen, die regelmässig geöffnet sind – wie Museen, Zoos,
          Schwimmbäder oder Bibliotheken.
        </p>
        <p className="text-sm text-gray-700 mb-2"><strong>Was wird eingegeben?</strong></p>
        <ul className="list-disc list-inside space-y-1 text-sm text-gray-700 mb-3">
          <li>Website der Einrichtung (z.B. <code>zoo.ch</code>), um Öffnungszeiten über Google Maps automatisch zu extrahieren</li>
          <li>Klick auf "Öffnungszeiten extrahieren" → Adresse und Zeiten werden automatisch gefüllt</li>
          <li>Manuelle Eingabe der Öffnungszeiten, wenn in Google Maps nicht hinterlegt</li>
          <li>Optional: Zeitraum bei saisonalen Angeboten (z.B. Freibad nur Mai-September)</li>
        </ul>
        <p className="text-sm text-gray-700 mb-2"><strong>Beispiele:</strong></p>
        <ul className="list-disc list-inside space-y-1 text-sm text-gray-700 mb-3">
          <li><strong>Zoo Zürich</strong> – täglich geöffnet, 9-18 Uhr</li>
          <li><strong>Stadtbibliothek Winterthur</strong> – Mo geschlossen, Di-Fr 10-19 Uhr, Sa 10-16 Uhr</li>
          <li><strong>Freibad Geiselweid</strong> – nur 1. Mai bis 30. September, täglich 9-20 Uhr</li>
        </ul>
        <p className="text-sm text-gray-700">
          <strong>Wichtig:</strong> Für spezielle Events in einer Einrichtung (z.B. "Osterworkshop im Zoo")
          verwenden Sie <strong>Einzeltermin(e)</strong>, nicht Öffnungszeiten!
        </p>
      </div>

      <div className="card p-6 mb-6">
        <h3> <Reccuring /> Wiederkehrend</h3>
        <p className="text-sm text-gray-700 mb-2"><strong>Wann verwenden?</strong></p>
        <p className="text-sm text-gray-700 mb-3">
          Für Aktivitäten, die regelmässig nach einem festen Muster stattfinden – z.B. jeden Mittwoch
          oder jeden ersten Sonntag im Monat.
        </p>
        <p className="text-sm text-gray-700 mb-2"><strong>Was wird eingegeben?</strong></p>
        <ul className="list-disc list-inside space-y-1 text-sm text-gray-700 mb-3">
          <li><strong>Wöchentlich:</strong> Welcher Wochentag? Jede Woche / jede 2. Woche / jede 4. Woche?</li>
          <li><strong>Monatlich:</strong> Welcher Wochentag? Erster/zweiter/dritter/vierter/letzter im Monat?</li>
          <li>Startzeit (z.B. 15:00)</li>
          <li>Endzeit (optional – falls die Endzeit nicht bekannt ist)</li>
          <li>Zeitraum: Von wann bis wann gilt das? (z.B. März-Juni 2025)</li>
        </ul>        
        <p className="text-sm text-gray-700">
          <strong>Wichtig:</strong> Für wöchentliche Events, die jede 2., 3. oder 4. Woche stattfinden, wird ein Termin verlangt,
          der beschreibt, ab wann die Aktivitäten stattfinden. Zum Beispiel: "Jeden zweiten Mittwoch, Start 5. März 2025". Das hilft uns, die Termine korrekt zu berechnen.
        </p>
        <ul className="list-disc list-inside space-y-1 text-sm text-gray-700 mb-3">
          <li><strong>Vorlesestunde Bibliothek</strong> – jeden Mittwoch, 15:00 Uhr, 45 Minuten, März-Dezember 2025</li>
          <li><strong>Familienführung Kunstmuseum</strong> – jeden ersten Sonntag im Monat, 11:00 Uhr, Dauer unbekannt</li>
          <li><strong>Kinderturnen</strong> – jeden zweiten Samstag, 10:00 Uhr, 90 Minuten, ganzjährig, Start 5. März 2025"</li>
        </ul>
        <p className="text-sm text-gray-700">
          <strong>Faustregel:</strong> Ab etwa 8 Wiederholungen lohnt sich "Wiederkehrend". Bei weniger
          Terminen ist "Einzeltermin(e)" einfacher.
        </p>
      </div>

      <div className="card p-6 mb-6">
        <h3> <OneTime /> Einzeltermin(e)</h3>
        <p className="text-sm text-gray-700 mb-2"><strong>Wann verwenden?</strong></p>
        <p className="text-sm text-gray-700 mb-3">
          Für Veranstaltungen an einem oder mehreren <strong>bestimmten Daten</strong> – z.B. Konzerte,
          Theater, Workshops, Kinderfeste.
        </p>
        <p className="text-sm text-gray-700 mb-2"><strong>Was wird eingegeben?</strong></p>
        <ul className="list-disc list-inside space-y-1 text-sm text-gray-700 mb-3">
          <li>Ein oder mehrere Termine (Datum + Uhrzeit)</li>
          <li>Endzeit (optional – falls Sie nicht wissen, wann es endet)</li>
          <li>Über "+ Weiteren Termin hinzufügen" können Sie mehrere Daten eingeben</li>
        </ul>
        <p className="text-sm text-gray-700 mb-2"><strong>Beispiele:</strong></p>
        <ul className="list-disc list-inside space-y-1 text-sm text-gray-700 mb-3">
          <li>
            <strong>Kindertheater "Die kleine Hexe"</strong> – drei Vorstellungen:
            <ul className="list-disc list-inside ml-4 mt-1">
              <li>5. März 2025, 19:00 Uhr</li>
              <li>12. März 2025, 19:00 Uhr</li>
              <li>19. März 2025, 19:00 Uhr</li>
            </ul>
          </li>
          <li><strong>Quartier-Sommerfest</strong> – 15. Juni 2025, 14:00 Uhr, Ende ca. 18:00 Uhr</li>
          <li><strong>Zoo Zürich Osterprogramm</strong> – 9. April 2025, 15:00 Uhr, Endzeit unbekannt</li>
        </ul>
        <p className="text-sm text-gray-700">
          <strong>Unterschied zu "Mehrtägig":</strong> Bei Einzelterminen kann man <strong>einen </strong>
          Termin auswählen und besuchen. Bei mehrtägigen Events gehören alle Tage zusammen.
        </p>
      </div>

      <div className="card p-6 mb-6">
        <h3> <Multiday /> Mehrtägig</h3>
        <p className="text-sm text-gray-700 mb-2"><strong>Wann verwenden?</strong></p>
        <p className="text-sm text-gray-700 mb-3">
          Für Events, die über <strong>mehrere aufeinanderfolgende Tage</strong> gehen und als Einheit
          zusammengehören – z.B. Workshops, Ferienlager, Ausstellungen, Festivals.
        </p>
        <p className="text-sm text-gray-700 mb-2"><strong>Was wird eingegeben?</strong></p>
        <ul className="list-disc list-inside space-y-1 text-sm text-gray-700 mb-3">
          <li>Daten des Events (z.B. 10., 11. und 14. März)</li>
          <li>Für jeden Tag wird die Startzeit und optional die Endzeit angegeben.</li>
        </ul>
        <p className="text-sm text-gray-700 mb-2"><strong>Beispiele:</strong></p>
        <ul className="list-disc list-inside space-y-1 text-sm text-gray-700 mb-3">
          <li><strong>Töpfer-Workshop für Kinder</strong> – Mo-Mi, 10.-12. März, täglich 9-12 Uhr</li>
          <li><strong>Sommerlager</strong> – 5 Tage, 20.-24. Juli, ganztägig (Zeiten variieren)</li>
          <li><strong>Kunstausstellung "Kinderträume"</strong> – 14 Tage, 1.-14. September, täglich 10-18 Uhr</li>
        </ul>
        <p className="text-sm text-gray-700">
          <strong>Wichtig:</strong> Man besucht typischerweise <strong>alle oder mehrere Tage</strong>
          des Events, nicht nur einen.
        </p>
      </div>

      <div className="card p-6 mb-6">
        <h3> <FreeAccess /> Frei zugänglich</h3>
        <p className="text-sm text-gray-700 mb-2"><strong>Wann verwenden?</strong></p>
        <p className="text-sm text-gray-700 mb-3">
          Für Orte, die keine festen Öffnungszeiten haben und grundsätzlich immer zugänglich sind –
          z.B. Spielplätze, Wanderwege, Feuerstellen, Parks.
        </p>
        <p className="text-sm text-gray-700 mb-2"><strong>Was wird eingegeben?</strong></p>
        <ul className="list-disc list-inside space-y-1 text-sm text-gray-700 mb-3">
          <li>Optional: Saisonale Einschränkung (z.B. "Nur im Sommer" oder "Im Winter geschlossen")</li>
          <li>Wenn saisonal: Von wann bis wann? (z.B. Mai-Oktober)</li>
        </ul>
        <p className="text-sm text-gray-700 mb-2"><strong>Beispiele:</strong></p>
        <ul className="list-disc list-inside space-y-1 text-sm text-gray-700 mb-3">
          <li><strong>Spielplatz Rosengarten</strong> – ganzjährig, keine Einschränkungen</li>
          <li><strong>Zwergenweg Braunwald</strong> – Wanderweg, nur Mai-Oktober (im Winter geschlossen)</li>
        </ul>
        <p className="text-sm text-gray-700">
          <strong>Unterschied zu "Öffnungszeiten":</strong> Es gibt keine festen Zeiten. Man kann
          jederzeit hingehen (eventuell mit saisonalen Einschränkungen).
        </p>
      </div>

      <hr className="mb-6" />

      <div className="card p-6 mb-6">
        <h3>❓ Immer noch unsicher?</h3>
        <h3>Entscheidungshilfe:</h3>
        <p className="text-sm text-gray-700 mb-2"><strong>Hat es fixe Öffnungszeiten?</strong></p>
        <p className="text-sm text-gray-700 mb-3">→ <strong>Öffnungszeiten</strong> (z.B. Museum Di-So 10-17 Uhr)</p>

        <p className="text-sm text-gray-700 mb-2"><strong>Findet es nach einem regelmässigen Muster statt?</strong></p>
        <p className="text-sm text-gray-700 mb-3">→ <strong>Wiederkehrend</strong> (z.B. jeden Mittwoch, jeden ersten Sonntag)</p>

        <p className="text-sm text-gray-700 mb-2"><strong>Findet es an bestimmten Daten statt?</strong></p>
        <p className="text-sm text-gray-700 mb-3">→ <strong>Einzeltermin(e)</strong> (z.B. Theater am 5., 12. und 19. März)</p>

        <p className="text-sm text-gray-700 mb-2"><strong>Geht es über mehrere zusammenhängende Tage?</strong></p>
        <p className="text-sm text-gray-700 mb-3">→ <strong>Mehrtägig</strong> (z.B. Workshop Mo-Mi)</p>

        <p className="text-sm text-gray-700 mb-2"><strong>Kann man jederzeit hingehen?</strong></p>
        <p className="text-sm text-gray-700">→ <strong>Frei zugänglich</strong> (z.B. Spielplatz, Wanderweg)</p>
      </div>

      <hr className="mb-6" />

      <div className="card p-6 mb-6">
        <h3>💡 Tipps</h3>
        <ul className="list-disc list-inside space-y-1 text-sm text-gray-700">
          <li><strong>Sie können ein Event nicht zweimal eintragen.</strong> Falls Sie sich vertippen, können Sie es nach der Eingabe noch anpassen.</li>
          <li><strong>Bei Unsicherheit:</strong> Wählen Sie die einfachste Kategorie. Das Moderationsteam kann Ihnen später helfen, wenn nötig.</li>
          <li><strong>Endzeiten sind oft optional.</strong> Wenn Sie nicht wissen, wann ein Event endet, können Sie das Feld leer lassen.</li>
          <li><strong>Bei Fragen:</strong> Kontaktieren Sie uns unter <a href="mailto:hello@grosskinder-aktiv.ch" className="text-blue-500 underline">hello@grosskinder-aktiv.ch</a></li>
        </ul>
      </div>

      <p className="text-sm text-gray-700"><strong>Viel Erfolg beim Eintragen!</strong> 🎉</p>
    </div>
  );
};

export default ZeitangabenFormate;
